import { COMPANY } from '@repo/domain';

const env: 'development' | 'staging' | 'production' = (import.meta.env
  .VITE_STAGE || 'staging') as 'development' | 'staging' | 'production';

export const config = {
  company: COMPANY,
  env,
} as const;
